import React from 'react';

const StepIndicator = ({ step, color }) => {
    const activeStyle = {
        backgroundColor: color,
        borderColor: color,
        color: '#fff',
    };
    const inactiveStyle = {
        backgroundColor: '#fff',
        borderColor: '#afafaf',
        color: '#afafaf',
    };

    return (
        <div className="registration-step-indicator">
            <div className="registration-step-circle" style={activeStyle}>
                1
            </div>
            <div className="registration-step-line" />
            <div className="registration-step-circle" style={step === 2 ? activeStyle : inactiveStyle}>
                2
            </div>
        </div>
    );
};

export default StepIndicator;
